import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { KpiEdit, SynthesisData } from './types';

const KEY = ['ref-production-synthesis'];
const ENDPOINT = '/api/ref-production-synthesis';

async function requestData(url: string, init?: RequestInit): Promise<SynthesisData> {
    const response = await fetch(url, init);
    if (!response.ok) {
        throw new Error(`La synthèse de production n'a pas pu être chargée ou modifiée (${response.status}).`);
    }
    return response.json();
}

export function useSynthesis() {
    return useQuery({ queryKey: KEY, queryFn: () => requestData(ENDPOINT) });
}

export function useEditSynthesis() {
    const client = useQueryClient();
    return useMutation({
        mutationFn: (edit: KpiEdit) => requestData(ENDPOINT, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(edit),
        }),
        onSettled: () => client.invalidateQueries({ queryKey: KEY }),
    });
}
